import { colors } from '@utils/tailwind';
import React from 'react';
import { ActivityIndicator, ActivityIndicatorProps } from 'react-native';

interface Props extends ActivityIndicatorProps {}

export function EcoLoader({ size, color = colors.white, style }: Props): JSX.Element {
  return <ActivityIndicator size={size} color={color} style={style} />;
}
